import { GenerateSubSelector, createSubSelector } from '../spaceKeyedSelectors';
import { IEditorInfoState } from './EditorInfoReducer';

export const SelectProject = GenerateSubSelector<IEditorInfoState>('project');

export const SelectScriptEditorInfo = createSubSelector(state => state.project.scriptEditorInfo);
